export default __webpack_public_path__ + "static/media/BrakeMaintenance4.d2af74ad.png";